import { render } from "./PrinterDetail.vue?vue&type=template&id=46e0e325"
import script from "./PrinterDetail.vue?vue&type=script&lang=js"
export * from "./PrinterDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__